import React from "react";
import "./notes.css";
import Button from "../components/shared/Button";

// Import images
import bubbleImg from "../assets/Images/bubble.jpg";
import insertionImg from "../assets/Images/insertion.png";
import mergeImg from "../assets/Images/merge.png";
import quickImg from "../assets/Images/Quick.png";
import selectionImg from "../assets/Images/selection.png";
import dfsImg from "../assets/Images/DFS.jpg";
import bfsImg from "../assets/Images/BFS.png";
import bmImg from "../assets/Images/bm.png";
import kmpImg from "../assets/Images/kmp.png";
import linkedListImg from "../assets/Images/linkedlist.png";
import stackImg from "../assets/Images/stack.jpg";
import tspImg from "../assets/Images/tsp.png";

const NotesPage = () => {
  const sortingAlgorithms = [
    {
      algorithm: "Bubble Sort",
      imageUrl: bubbleImg,
      pdfUrl: "/notespdf/BUBBLESORTALGORITHM.pdf",
    },
    {
      algorithm: "Insertion Sort",
      imageUrl: insertionImg,
      pdfUrl: "/notespdf/INSERTIONSORTALGORITHM.pdf",
    },
    {
      algorithm: "Merge Sort",
      imageUrl: mergeImg,
      pdfUrl: "/notespdf/MERGESORTALGORITHM.pdf",
    },
    {
      algorithm: "Quick Sort",
      imageUrl: quickImg,
      pdfUrl: "/notespdf/QUICKSORTALGORITHM.pdf",
    },
    {
      algorithm: "Selection Sort",
      imageUrl: selectionImg,
      pdfUrl: "/notespdf/SELECTIONSORTALGORITHM.pdf",
    },
    {
      algorithm: "Depth First Search (DFS)",
      imageUrl: dfsImg,
      pdfUrl: "/notespdf/DFS.pdf",
    },
    {
      algorithm: "Breadth First Search (BFS)",
      imageUrl: bfsImg,
      pdfUrl: "/notespdf/BFS.pdf",
    },
    {
      algorithm: "Boyer Moore",
      imageUrl: bmImg,
      pdfUrl: "/notespdf/BOYERMOORE.pdf",
    },
    {
      algorithm: "KnuthMorrisPratt(KMP)",
      imageUrl: kmpImg,
      pdfUrl: "/notespdf/KNUTHMORRISPRATT.pdf",
    },
    {
      algorithm: "Linked List",
      imageUrl: linkedListImg,
      pdfUrl: "/notespdf/LinkedList.pdf",
    },
    {
      algorithm: "Red Black Tree",
      imageUrl: bfsImg, // You used BFS.png again — update if you have a separate image
      pdfUrl: "/notespdf/REDBLACKTREE.pdf",
    },
    {
      algorithm: "Stack and Queue",
      imageUrl: stackImg,
      pdfUrl: "/notespdf/STACKQUEUE.pdf",
    },
    {
      algorithm: "Travelling Salesman Problem",
      imageUrl: tspImg,
      pdfUrl: "/notespdf/TSP.pdf",
    },
  ];

  return (
    <div className="notes-page-container">
      <h1 className="notes-title">Master the Basics: DSA Starter Pack</h1>
      <hr className="notes-divider" />

      <div className="notes-grid">
        {sortingAlgorithms.map((algorithm, index) => (
          <div className="note-card" key={index}>
            <img
              src={algorithm.imageUrl}
              alt={`${algorithm.algorithm} illustration`}
              className="algorithm-image"
            />
            <h2 className="algorithm-title">{algorithm.algorithm}</h2>
            <div className="button-container">
              <Button
                aria-label={`View notes for ${algorithm.algorithm}`}
                onClick={() => {
                  const newTab = window.open(algorithm.pdfUrl, "_blank");
                  if (!newTab) {
                    alert("Failed to open PDF. Please check the file path.");
                  }
                }}
              >
                View Notes
              </Button>
              <a
                href={algorithm.pdfUrl}
                download
                className="download-btn"
                aria-label={`Download PDF for ${algorithm.algorithm}`}
              >
                Download PDF
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotesPage;
